export default __webpack_public_path__ + "static/media/image 3-2.41f6883b.png";